import type { CoachProfile, TrainingSetting } from '@trainme/db/client';
import { create } from 'zustand';

interface SettingsState {
  trainingSettings:
    | (TrainingSetting & { coachProfile: CoachProfile | null })
    | null;
  setTrainingSettings: (
    settings: (TrainingSetting & { coachProfile: CoachProfile | null }) | null
  ) => void;
  getSportsSpeeds: () =>
    | Record<string, number | Record<string, number>>
    | null
    | undefined;
}

export const useSettingsStore = create<SettingsState>((set, get) => ({
  trainingSettings: null,

  setTrainingSettings: (settings) => {
    set({ trainingSettings: settings });
  },

  getSportsSpeeds: () => {
    const settings = get().trainingSettings;
    return settings?.sportsSpeeds as
      | Record<string, number | Record<string, number>>
      | null
      | undefined;
  },
}));
